<ng-container *ngIf="isActiveSwitchUser">
    <button mat-menu-item class="profile-switch-button" (click)="showAccessUserModal()">
        <i class="ri-user-follow-line"></i>
        Delegate User Access
    </button>    
</ng-container>
<button mat-menu-item class="profile-switch-button" (click)="backToMainProfile()" *ngIf="!isActiveSwitchUser">
    <i class="ri-arrow-go-back-line"></i>
    Exit
</button>